import { RECRUITERCLIENTMATCHINGJOBS } from "../../ENVIRONMENT";

function recrejectApplication(token,id) {
    // api for reject application
    return fetch(RECRUITERCLIENTMATCHINGJOBS + "/reject",{
        
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json',
                    'Authorization':`Bearer ${token?token:sessionStorage.getItem('token')}` },
        body: JSON.stringify(id)

    })
    
}

export { recrejectApplication };

